export default "__VITE_ASSET__BbUN7P37__"